function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M40 58.067L60.6 70.5l-5.466-23.433 18.2-15.767-23.967-2.067-9.366-22.066-9.367 22.066L6.667 31.3l18.167 15.767L19.401 70.5 40 58.067z",
  fill: "#DFE8F6"
});

function SvgImage3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/image3.2a9dcebc.svg";
export { SvgImage3 as ReactComponent };